import { render, staticRenderFns } from "./RecipeDetailPopup.vue?vue&type=template&id=4e553565"
import script from "./RecipeDetailPopup.vue?vue&type=script&lang=js"
export * from "./RecipeDetailPopup.vue?vue&type=script&lang=js"
import style0 from "./RecipeDetailPopup.vue?vue&type=style&index=0&id=4e553565&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports